import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Alert, Button } from "~/components-shared";
import { StatusStateEnum, TopicStatusEnum, TopicVisibilityEnum } from "~/types/enums";
import { useDispatch, useSelector } from "react-redux";
import onboardingActionCreators from "~/store/onboarding/actions";
import toastsActionCreators from "~/store/toasts/actions";
import moment from "moment";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import topicSchema from "~/forms/TopicForm/topicSchema";
import topicActionCreators from "~/store/topics/actions";
import topicSelectors from "~/store/topics/selectors";
import { useIntegratedSources } from "~/hooks/integrations";
import TopicForm from "~/forms/TopicForm";
const Actions = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: right;
  margin-top: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.spacing.step * 5;
}}px;
  margin-bottom: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing.step * 2;
}}px;
`;
const OnboardingTopicsCreate = _ref3 => {
  let {
    template,
    onSuccess,
    onBack,
    ...rest
  } = _ref3;
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  const status = useSelector(topicSelectors.getStatusByTopic("+"));
  const error = useSelector(topicSelectors.getErrorByTopic("+"));
  const sources = useIntegratedSources();
  const includeRetro = !!sources.length;
  const defaultValues = {
    name: template?.name || "",
    description: template?.description || "",
    sources,
    visibility: TopicVisibilityEnum.STAKEHOLDERS,
    memberIds: [],
    tags: [],
    trigger: template?.trigger || "",
    keywords: template?.keywords || " ",
    ownerId: "",
    status: TopicStatusEnum.ACTIVE,
    startDate: moment().toISOString(),
    markSlackAiDetections: false,
    settings: {},
    targets: template?.targets.map(_ref4 => {
      let {
        name,
        description,
        color,
        duration
      } = _ref4;
      return {
        name,
        description,
        color,
        duration,
        memberIds: [],
        sources
      };
    })
  };
  const {
    handleSubmit,
    control,
    watch,
    trigger,
    setValue
  } = useForm({
    resolver: yupResolver(topicSchema),
    defaultValues
  });
  const onSkip = () => {
    dispatch(onboardingActionCreators.companyTopicsSkipStarted());
  };
  const onCreateSubmit = handleSubmit(data => {
    dispatch(topicActionCreators.createStarted(data, _ref5 => {
      let {
        data: newTopic
      } = _ref5;
      if (newTopic) {
        dispatch(toastsActionCreators.pushed({
          severity: "success",
          message: t("OnboardingTopicsCard.topicCreated", {
            name: watch("name")
          }),
          timeout: 10000
        }));
        if (includeRetro) {
          onSuccess(newTopic);
        } else {
          dispatch(onboardingActionCreators.companyTopicsSubmitStarted());
        }
      }
    }));
  });
  return /*#__PURE__*/React.createElement("form", _extends({
    onSubmit: onCreateSubmit
  }, rest), error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(TopicForm, {
    control: control,
    watch: watch,
    trigger: trigger,
    setValue: setValue,
    fromTemplate: true,
    singleColumn: true
  }), /*#__PURE__*/React.createElement(Actions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onBack,
    color: "transparent",
    s: {
      px: 8,
      mr: 3
    },
    disabled: status === StatusStateEnum.LOADING,
    rounded: true
  }, t("common.actions.back")), /*#__PURE__*/React.createElement(Button, {
    onClick: onSkip,
    color: "grey",
    s: {
      px: 8,
      mr: 3
    },
    disabled: status === StatusStateEnum.LOADING,
    rounded: true
  }, t("common.actions.skip")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onCreateSubmit,
    loading: status === StatusStateEnum.LOADING,
    disabled: !template,
    s: {
      ml: 2
    },
    fullWidth: true,
    rounded: true,
    shadow: true
  }, t("common.actions.save"))));
};
export default OnboardingTopicsCreate;